import globalscripts from './global-scripts';
import facetedsearch from './faceted-search';
import header from '../../components/header';
import footer from '../../components/footer';
import herobanner from '../../components/hero-banner';
import globalsearchtoggle from '../../components/global-search-toggle';
import notificationbar from '../../components/notification-bar';
import orders from '../../components/orders';

globalscripts();
facetedsearch();
header();
footer();
herobanner();
globalsearchtoggle();
notificationbar();
orders();
